import React from "react";
import { Button } from "react-bootstrap";

const eventIcon = (type) => {
  if (type === "organization_removal" || type === "leads delete") {
    return "fa fa-user-times";
  }
  if (type === "package_assignment") return "fa fa-cube";
  return "fa fa-exchange";
};

const packagePeriod = (item) => {
  if (!item.package_start_date && !item.package_end_date) return null;
  return (
    (item.package_start_date || "Start date not recorded") +
    " to " +
    (item.package_end_date || "End date not recorded")
  );
};

const AssignmentHistoryPanel = ({ history, formatDate, onRetry }) => {
  const resource = history || { data: [] };
  const records = resource.data || [];

  return (
    <section
      className="cw-panel cw-assignment-activity"
      aria-labelledby="assignment-activity-title"
    >
      <div className="cw-assignment-activity__heading">
        <h2 id="assignment-activity-title">
          Organization &amp; Package Activity
        </h2>
        {!resource.loading && !resource.error && records.length ? (
          <span>{records.length}</span>
        ) : null}
      </div>

      {resource.error ? (
        <p className="cw-tab-error" role="alert">
          {resource.error}{" "}
          <Button bsStyle="link" onClick={onRetry}>
            Retry
          </Button>
        </p>
      ) : null}
      {resource.loading ? (
        <p className="cw-muted" role="status">
          Loading organization and package activity…
        </p>
      ) : null}
      {!resource.loading && !resource.error && !records.length ? (
        <p className="cw-muted">No organization or package activity recorded.</p>
      ) : null}

      {!resource.loading && !resource.error && records.length ? (
        <ol className="cw-assignment-timeline">
          {records.map((item) => {
            const period = packagePeriod(item);
            return (
              <li key={item.id}>
                <span className="cw-assignment-timeline__icon" aria-hidden="true">
                  <i className={eventIcon(item.event_type)} />
                </span>
                <div className="cw-assignment-timeline__content">
                  <div className="cw-assignment-timeline__title">
                    <strong>{item.title || "Assignment updated"}</strong>
                    <time>{formatDate(item.occurred_at, true)}</time>
                  </div>
                  <dl>
                    {item.organization_name ? (
                      <div>
                        <dt>Organization</dt>
                        <dd>{item.organization_name}</dd>
                      </div>
                    ) : null}
                    {item.package_name ? (
                      <div>
                        <dt>Package</dt>
                        <dd>{item.package_name}</dd>
                      </div>
                    ) : null}
                    {period ? (
                      <div>
                        <dt>Period</dt>
                        <dd>{period}</dd>
                      </div>
                    ) : null}
                    <div>
                      <dt>Changed by</dt>
                      <dd>{item.changed_by || "System"}</dd>
                    </div>
                  </dl>
                  {item.details ? <p>{item.details}</p> : null}
                </div>
              </li>
            );
          })}
        </ol>
      ) : null}
    </section>
  );
};

export default AssignmentHistoryPanel;
